import {graphql} from 'react-relay'

export const query = graphql`
  query BuildStatusWidgetQuery($btLocator: String!) {
    buildType(btLocator: $btLocator) {
      externalStatusAllowed
    }
  }
`
